export default "__VITE_ASSET__BLwgQU76__"